export const setSchemeInfoDetailsAgainstInvestor=(data)=>{
    return {
        type: "SET_SCHEME_INFO_AGAINST_INVESTOR",
        info: data,
    }
}
export const nullSchemeInfoDetailsAgainstInvestor=()=>{
    return{
        type:"NULL_SCHEME_INFO_AGAINST_INVESTOR",
        info: null
    }
}
export const getSchemeInfoDetailsAgainstInvestor=()=>{
    return {
        type: "GET_SCHEME_INFO_AGAINST_INVESTOR",
        
    }
}
